import React from 'react'
import PropTypes from 'prop-types'
import { CloseIcon } from '@ow/icons'
// import { dealCtxInfo } from './hooks/useWatermark'
import { StyledHeader } from './styled'

const Header = (props) => {
  const { currentFile = {}, onClose } = props
  const { filename } = currentFile
  // let link = src
  // if (src.lastIndexOf('?')) {
  //   const endIndex = src.lastIndexOf('?')
  //   link = src.slice(0, endIndex + 1)
  // }

  return (
    <StyledHeader
      className="w-full flex items-center justify-between text-white h-16 absolute left-0 top-0"
      style={{ zIndex: '9996' }}
    >
      <div className="flex items-center gap-5" style={{ maxWidth: '300px' }}>
        <h4 className="title overflow-ellipsis overflow-hidden">{filename}</h4>
        {/* <div
          className="w-4 h-4 cursor-pointer"
          onClick={() => {
            onClickImage(src)
          }}
        >
          <DownloadIcon width={18} height={18} fill="#fff" />
        </div> */}
      </div>

      <div
        className="close cursor-pointer"
        onClick={() => {
          onClose()
        }}
      >
        <CloseIcon width={18} height={18} fill="#fff" />
      </div>
    </StyledHeader>
  )
}

Header.propTypes = {
  currentFile: PropTypes.shape({}),
  onClose: PropTypes.func,
}

Header.defaultProps = {
  currentFile: undefined,
  onClose: () => {},
}
export default Header
